export const STORE_KEY_AUTH = 'wg-2.0-platform-authStore'